export enum SelectOptions {
  SELECT_ALL = 'selectAll',
  DISPLAYED = 'displayed',
  FILTERED = 'filtered',
}

export enum ManufacturerValidationStatus {
  VALID = 'valid',
}
